const getReplacementConfirmationModuleAssetUrl = () => {
	return new Worker(new URL("../../workers/replacementConfirmationPDFWorker.worker.tsx", import.meta.url), {
		type: "module"
	});
};

export default getReplacementConfirmationModuleAssetUrl;
